import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';
import FormDialog from "../FormDialog/FormDialog"

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },

}));

const Toolbar = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const [op, setOp] = useState(false)



  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <h2>Իրավասություններ</h2>
      <div className={classes.row}>
        <span className={classes.spacer} />
        <Button
          // className={classes.btn}
          color="primary"
          variant="contained"
          onClick={() => { setOp(true) }}
          style={{ marginBottom: "10px" }}
        >
          Ավելացնել
                        </Button>
        <FormDialog op={op} setOp={setOp} />

      </div>

    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
